<script setup lang="ts">
import { computed } from 'vue';
import { useRoute } from 'vue-router';

import EmptyLayout from '@/shared/layouts/EmptyLayout.vue';
import MainLayout from '@/shared/layouts/MainLayout.vue';

const route = useRoute();
const layoutName = computed<'main' | 'empty'>(() => (route.meta.layout === 'empty' ? 'empty' : 'main'));
</script>

<template>
  <MainLayout v-if="layoutName === 'main'" />
  <EmptyLayout v-else />
</template>
